module.exports = __webpack_public_path__ + "img/wkxsj_img.b6f52eb5.png";